

import logoEquinox from "../src/Assets/Images/logo.png";
import logoDemmy from "../src/Assets/Images/logo.png";
import logoOcay from "../src/Assets/Images/Ocay.png";
import logoHamed from "../src/Assets/Images/Hamed.png";
import logoEquinoxPrivacy from "../src/Assets/Images/Equinox.png";
import logoOlumajekPrivacy from "../src/Assets/Images/Olumajek.png";

const faviconLogoOcay = './Ocay.png';

const BRANDING = {
  equinox: {
    brandName: "Equinox",
    businessName: "equinox", 
    logo: logoEquinox,
    privacyLogo: logoEquinoxPrivacy,
    color: {
      primary: "#1C0F5E",
      secondary: "#A89DF1",
    },
  },
  ocay: {
    brandName: "Olumajek IT Continental",
    businessName: "Olumajek_IT_Continental_LTD", 
    logo: logoOcay,
    privacyLogo: logoOlumajekPrivacy,
    faviconLogos: faviconLogoOcay,
    color: {
      primary: "#161032",
      secondary: "#A2D6F9",
    },
  },
  alhamedglobal: {
    brandName: "ALHAMED OLA GLOBAL TELECOM LTD",
    businessName: "alhamed", 
    logo: logoHamed,
    faviconLogos: faviconLogoOcay,
    color: {
      primary: "#0000FF",
      secondary: "#A2D6F9",
    },
  },
  demmy: {
    brandName: "Demmy",
    businessName: "", 
    logo: logoDemmy,
    color: {
      primary: "#2948CE",
      secondary: "#21ADE3",
    },
  },
  default: {
    brandName: "Equinox",
    businessName: "",
    logo: logoEquinox,
    color: {
      primary: "#1C0F5E",
      secondary: "#A89DF1",
    },
  },
};

export default BRANDING;
